import { safeCall } from "@noli/core";

import { loginStore } from "@/modules/login/store";
// import { Dictionary } from "@/types/base";
import Axios from "@/utils/Axios";
import config from "@/config";

export async function getGlobalPending(): Promise<number> {
  if (loginStore.isGuest) return 0;
  return safeCall(
    () =>
      fetch(`${process.env.REACT_APP_MAIN_URL}/ai_creator/engine/server_status`, {
        method: "GET",
        headers: loginStore.getReqHeaders,
      })
        .then((data) => data.json())
        .then((json) => json.num_pending ?? 0),
    {
      success: async () => void 0,
      failed: async () => 0,
    },
  );
}

// interface PostBatchTaskRequest {
//   batch_id: string;
//   tasks: Array<{
//     task: string;
//     params: Dictionary<any>;
//     serial_number: string;
//     custom_embeddings?: string[];
//     model_type?: /** 画宇宙模型 */ 1 | /** 画宇宙动漫模型 */ 2 | /** 画宇宙小模型 */ 3;
//   }>;
// }
// /**
//  * 批量提交任务
//  * @param data
//  * @returns
//  */
// export async function postBatchTask(data: PostBatchTaskRequest) {
//   return Axios.post("/task/push", data, {}, config.creatorUrl);
// }

// /**
//  * 查询一个批次下的任务结果
//  * @returns
//  */

// interface GetBatchTaskStatusRequest {
//   batch_id: string;
//   serial_numbers: string[];
// }
// export async function getBatchTaskStatus(params: GetBatchTaskStatusRequest) {
//   return Axios.post("/task/query/queue", params, {}, config.creatorUrl);
// }

export function cancelBatchTasks(batchIds: string[]) {
  return Axios.post("/task/cancel/batch", { batch_ids: batchIds }, {}, config.creatorUrl);
}
